import { Directive, inject, input, output, signal } from '@angular/core';
import { LanguageService } from '@uigy/shared/services/language.service';
import Utils from '@uigy/utils';
import { BadgeConfig } from '../../ui-badge/ui-badge.interfaces';

@Directive()
export abstract class KpiSmallBaseComponent {
  public text = input.required<string>();
  public badgeConfig = input<BadgeConfig>();
  public isLoading = input<boolean>(false);
  public isClickable = input<boolean>(true);
  public isLaptopScreen = signal<boolean>(false);
  public clicked = output<void>();

  protected readonly Utils = Utils;
  protected languageService = inject(LanguageService);
  protected readonly LARGE_SCREEN = Number(Utils.getCssVariableValue('--full-hdpi-size').replace('px', ''));

  constructor() {

  }
}
